import script from "./AnnouncementForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementForm.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementForm.vue?vue&type=style&index=0&id=0c367121&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c367121"]])

export default __exports__